import {
  EmptyState,
  UpgradingIllustration,
} from '@angeplus/prever-component-lib';
import { routes } from 'modules/routes';

export const ContractEmptyState = () => {
  const handleRedirect = (url: string) => () => window.location.assign(url);

  return (
    <EmptyState
      illustration={<UpgradingIllustration />}
      description={'Você não possui plano vinculado ao seu cadastro Angeplus.'}
      buttonLabelPrimary="Já tenho plano"
      onClickButtonPrimary={handleRedirect(routes.links.new.card)}
      buttonLabelSecondary="Adquirir plano"
      onClickButtonSecondary={handleRedirect(routes.plan)}
    />
  );
};
